import { z } from "zod/v4";

import { createEndpointBase } from "./core";
import { NumberSequenceSchemas } from "../ea.schema";
import { CountResponseSchema } from "../ea.schema.endpoints";
import { GetRequestBaseResponseSchema, NumberSequenceFilterSchema } from "../ea.schema.query";

const base = "number-sequences";
const ns = createEndpointBase(base);

export const numberSequencesEndpoints = {
  numberSequencesGet: ns({
    method: "GET",
    path: "",
    request: z.object({ filter: NumberSequenceFilterSchema.optional() }).optional(),
    response: GetRequestBaseResponseSchema(NumberSequenceSchemas["general"]),
    description: "Retrieves a list of number sequences with filtering support.",
  }),
  numberSequencesCount: ns({
    method: "GET",
    path: "count",
    request: z
      .object({ filter: NumberSequenceFilterSchema.pick({ where: true }).optional() })
      .optional(),
    response: CountResponseSchema,
    description: "Returns the total number of number sequences matching the filters.",
  }),
  numberSequencesCreate: ns({
    method: "POST",
    path: "",
    request: NumberSequenceSchemas["create"],
    response: NumberSequenceSchemas["general"],
    description: "Creates a new number sequence.",
  }),
  numberSequencesUpdate: ns({
    method: "PATCH",
    path: ":id",
    request: NumberSequenceSchemas["update"],
    response: NumberSequenceSchemas["general"],
    description: "Updates an existing number sequence.",
  }),
  numberSequencesDelete: ns({
    method: "DELETE",
    path: ":id",
    request: z.object({ id: z.number() }),
    response: z.any(),
    description: "Permanently deletes a number sequence.",
  }),
  numberSequencesNext: ns({
    method: "GET",
    path: "next",
    request: z.any(),
    response: z.object({ value: z.string() }),
    description: "Retrieves the next value in the specified number sequence.",
  }),
} as const;
